import React from "react";
import PropTypes from "prop-types";
import AddContactRow from "./AddContactRow";
import EditContactRow from "./EditContactRow";
import ViewContactRow from "./ViewContactRow";

const ContactRow = (props) => {
  const { mode, onSelectContact } = props;
  if (mode === "add") {
    return <AddContactRow {...props} />;
  } else if (mode === "edit") {
    return <EditContactRow {...props} onSelectContact={onSelectContact} />;
  } else {
    return <ViewContactRow {...props} onSelectContact={onSelectContact} />;
  }
};

ContactRow.propTypes = {
  mode: PropTypes.oneOf(["add", "edit", "view"]).isRequired,
  row: PropTypes.shape({
    roleKey: PropTypes.string.isRequired,
    roleLabel: PropTypes.string.isRequired,
    contact: PropTypes.object,
  }).isRequired,
  onRowClick: PropTypes.func,
  onSelectContact: PropTypes.func,
  selectedContact: PropTypes.object,
};

export default ContactRow;
